import { render } from "./Webhumsafar.vue?vue&type=template&id=2239fbe4"
import script from "./Webhumsafar.vue?vue&type=script&lang=js"
export * from "./Webhumsafar.vue?vue&type=script&lang=js"

import "./Webhumsafar.vue?vue&type=style&index=0&id=2239fbe4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__